module.exports = __webpack_public_path__ + "media/images/flags/4x3/slb-ce4d6414dcb54322eb6e358283033ef5.svg";